import React from "react"
import { useSelector } from "react-redux"
import ProjectDetailsEditForm from "../../quote/project/details.component"
import { InventoryStockDocumentSelector } from "../../state/inventory"
import { DetailEditProps } from "../../common/types/project"

export const StockDocumentDetailsEdit = (props: DetailEditProps) => {
    const doc = useSelector(InventoryStockDocumentSelector.get)

    return (
        <div className={"mx-auto px-4"}>
            <ProjectDetailsEditForm
                stockDocument={doc}
                isEditable={props.isEditable}
            />
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/project/sections/StockDocumentDetailsEdit.tsx